import { InjectionToken } from '@angular/core';
import { RequestInfo } from '@farris/bef';
import { BsModalRef } from '@farris/ui-modal';
// tslint:disable: unified-signatures
export const TAB_EVENT = {
  /**
   * Tabå³é­å
   */
  onTabClosed: 'FuncClosed',
  /**
   * Tabå³é­å
   */
  onTabClosing: 'beforeFuncCloseEvent',
  /**
   * Tabåæ¢
   */
  onTabSwitched: 'funcSwitchEvent'
};

export const TAB_QUERY_STRING = {
  TabId: 'tabId',
  AppType: 'appType',
  AppId: 'appId',
  AppEntrance: 'appEntrance',
  FuncId: 'funcId'
};

/**
 * å¸¦RequestInfoçbodyå¯¹è±¡
 */
export interface BodyWithRequestInfo {
  requestInfo: RequestInfo;
  [key: string]: any;
}

export const WEB_FORM_ROUTE_PARAMS_KEY = 'WEB_FORM_ROUTE_PARAMS';
export const enum DataType {
  map = '[object Map]'
}
export type KeyObject<T = any> = { key: T };

export const INSIDE_DIALOG_TOKEN = new InjectionToken<boolean>('@farris/command-service-inside-dialog');

export const MODAL_REF = new InjectionToken<BsModalRef>('@farris/command-service-modal-ref');

export namespace GspFramework {
  /**
   * æ¡æ¶ç¨æ·ä¿¡æ¯æè¿°
   */
  export type UserInfo = {
    id: string;
    code: string;
    name: string;
    orgId: string;
    orgName: string;
    lanName: string;
    languageId: string;
    unitId: string;
    unitName: string;
  };
  /**
   * æ¡æ¶ç¨æ·æå¡
   */
  export type UserInfoService = {
    get: () => UserInfo
  };
  /**
   * æ¡æ¶commonæå¡
   */
  export type CommonService = {
    userInfos: UserInfoService
  };
  export type RuntimeFrameworkService = {
  };
  /**
   * æ¡æ¶æå¡
   */
  export type FrameworkService = {
    common: CommonService,
    rtf: RuntimeFrameworkService
  };
}
